import React, { SVGProps } from "react";
const SvgFoodRestaurantAndEvents = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={26.448} viewBox="0 0 26.448 26.37" {...props}>
      <g data-name="Food, Restaurant and Events">
        <g data-name="Group 214">
          <path
            data-name="Path 686"
            d="M24.327 20.465H2.12a1.733 1.733 0 0 1-1.73-1.733v-.341a1.733 1.733 0 0 1 1.733-1.733h22.204a1.733 1.733 0 0 1 1.733 1.733v.341a1.733 1.733 0 0 1-1.733 1.733Z"
            fill="#e94444"
          />
        </g>
        <g data-name="Group 215">
          <path
            data-name="Path 687"
            d="M24.327 13.659H2.12a1.733 1.733 0 0 1-1.73-1.733v-.341a1.733 1.733 0 0 1 1.733-1.733h22.204a1.733 1.733 0 0 1 1.733 1.733v.341a1.733 1.733 0 0 1-1.733 1.733Z"
            fill="#9e5528"
          />
        </g>
        <g data-name="Group 216">
          <path
            data-name="Path 688"
            d="M26.061 18.39v.341a1.733 1.733 0 0 1-1.733 1.734h-1.014a1.733 1.733 0 0 0 1.733-1.734v-.341a1.733 1.733 0 0 0-1.733-1.733h1.014a1.733 1.733 0 0 1 1.733 1.733Z"
            fill="#d83131"
          />
        </g>
        <g data-name="Group 217">
          <path
            data-name="Path 689"
            d="M26.061 11.584v.341a1.733 1.733 0 0 1-1.733 1.733h-1.014a1.733 1.733 0 0 0 1.733-1.733v-.341a1.733 1.733 0 0 0-1.733-1.733h1.014a1.733 1.733 0 0 1 1.733 1.733Z"
            fill="#904d24"
          />
        </g>
        <g data-name="Group 218">
          <path
            data-name="Path 690"
            d="M13.224.388C4.567.513 1.659 5.209.698 7.938a1.441 1.441 0 0 0 1.364 1.913h22.322a1.444 1.444 0 0 0 1.358-1.93C24.778 5.191 21.863.513 13.224.388Z"
            fill="#fe9738"
          />
        </g>
        <g data-name="Group 219">
          <path
            data-name="Path 691"
            d="M24.386 9.85h-.123a1.443 1.443 0 0 0 .287-1.452C23.584 5.667 20.67.989 12.03.864a17.947 17.947 0 0 0-5.621.9A16.759 16.759 0 0 1 13.225.387c8.64.125 11.554 4.8 12.52 7.534a1.444 1.444 0 0 1-1.359 1.929Z"
            fill="#fe860a"
          />
        </g>
        <g data-name="Group 220">
          <path
            data-name="Path 692"
            d="M24.328 20.465H2.121s-.766 3.7 3.592 5.153a7.277 7.277 0 0 0 2.307.365h10.409a7.277 7.277 0 0 0 2.307-.365c4.358-1.455 3.592-5.153 3.592-5.153Z"
            fill="#fe9738"
          />
        </g>
        <g data-name="Group 221">
          <path
            data-name="Path 693"
            d="M20.736 25.617a7.274 7.274 0 0 1-2.307.366h-1.176a7.274 7.274 0 0 0 2.308-.366c4.358-1.455 3.592-5.152 3.592-5.152h1.176s.765 3.698-3.593 5.152Z"
            fill="#fe860a"
          />
        </g>
        <g data-name="Group 222">
          <path
            data-name="Path 694"
            d="M24.368 17.348a1.022 1.022 0 0 1-1.674.785 1.634 1.634 0 0 0-1.114-.4c-1.394 0-1.394 1.1-2.787 1.1s-1.394-1.1-2.787-1.1-1.394 1.1-2.787 1.1-1.394-1.1-2.787-1.1-1.394 1.1-2.787 1.1-1.394-1.1-2.787-1.1a1.633 1.633 0 0 0-1.113.4 1.022 1.022 0 0 1-1.674-.785V15.3h22.3v2.048Z"
            fill="#bbec6c"
          />
        </g>
        <g data-name="Group 223">
          <path
            data-name="Path 695"
            d="M24.369 15.3v2.048a1.021 1.021 0 0 1-1.541.878 1 1 0 0 0 .5-.878V15.3Z"
            fill="#a2e62e"
          />
        </g>
        <g data-name="Group 224">
          <path
            data-name="Path 696"
            d="M2.08 13.659v1.656h2.391a.9.9 0 0 1 .9.9v4.77a1.151 1.151 0 1 0 2.3 0v-4.77a.9.9 0 0 1 .9-.9h15.797v-1.656Z"
            fill="#fee45a"
          />
        </g>
        <g data-name="Group 225">
          <path
            data-name="Path 697"
            d="M23.329 13.658h1.039v1.656h-1.039Z"
            fill="#fedf30"
          />
        </g>
        <g data-name="Group 226">
          <path
            data-name="Path 698"
            d="M9.651 4.37a.387.387 0 0 0 .341-.2l.336-.622a.387.387 0 1 0-.681-.368l-.336.622a.387.387 0 0 0 .34.572Z"
          />
          <path
            data-name="Path 699"
            d="M13.607 4.025v-.707a.387.387 0 1 0-.775 0v.707a.387.387 0 1 0 .775 0Z"
          />
          <path
            data-name="Path 700"
            d="M16.798 4.368a.387.387 0 0 0 .335-.582l-.355-.611a.387.387 0 0 0-.67.389l.355.611a.387.387 0 0 0 .335.193Z"
          />
          <path
            data-name="Path 701"
            d="M26.448 11.925v-.341a2.12 2.12 0 0 0-.919-1.746 1.84 1.84 0 0 0 .58-2.046A10.9 10.9 0 0 0 22.6 2.873 15.113 15.113 0 0 0 13.23 0h-.011A19.384 19.384 0 0 0 8.39.638a.387.387 0 1 0 .2.747 18.608 18.608 0 0 1 4.63-.61c8.379.123 11.212 4.611 12.155 7.275a1.057 1.057 0 0 1-.993 1.413H2.062a1.047 1.047 0 0 1-.862-.447 1.032 1.032 0 0 1-.134-.95 10.185 10.185 0 0 1 5.88-6.114.387.387 0 0 0-.3-.714 11.365 11.365 0 0 0-4.378 3.17 10.91 10.91 0 0 0-1.933 3.4 1.8 1.8 0 0 0 .231 1.656 1.829 1.829 0 0 0 .354.374A2.119 2.119 0 0 0 0 11.584v.341a2.124 2.124 0 0 0 1.693 2.077l-.008 2.313A2.124 2.124 0 0 0 0 18.391v.341a2.124 2.124 0 0 0 1.691 2.077 4.97 4.97 0 0 0 .222 1.805 5.441 5.441 0 0 0 3.677 3.371 7.66 7.66 0 0 0 2.43.385h10.408a7.66 7.66 0 0 0 2.43-.385 5.441 5.441 0 0 0 3.677-3.371 4.97 4.97 0 0 0 .222-1.805 2.124 2.124 0 0 0 1.691-2.077v-.341a2.123 2.123 0 0 0-1.693-2.076v-2.313a2.124 2.124 0 0 0 1.693-2.077ZM.775 18.732v-.341a1.347 1.347 0 0 1 .908-1.271v.224a1.409 1.409 0 0 0 2.307 1.084 1.255 1.255 0 0 1 .867-.317h.128v1.958H2.121a1.347 1.347 0 0 1-1.346-1.337Zm15.435-3.03h7.772v1.642a.618.618 0 0 1-.361.571.627.627 0 0 1-.68-.085 2.014 2.014 0 0 0-1.36-.493 2.358 2.358 0 0 0-1.634.636 1.654 1.654 0 0 1-2.306 0 2.358 2.358 0 0 0-1.634-.636 2.387 2.387 0 0 0-1.634.636 1.654 1.654 0 0 1-2.306 0 2.387 2.387 0 0 0-1.634-.636 2.358 2.358 0 0 0-1.634.636 1.892 1.892 0 0 1-.736.42v-2.178a.514.514 0 0 1 .513-.513h5.819a.387.387 0 1 0 0-.775H8.574a1.289 1.289 0 0 0-1.288 1.288v4.77a.764.764 0 1 1-1.528 0v-4.77a1.289 1.289 0 0 0-1.288-1.288h-2v-.883h21.511v.882h-7.772a.387.387 0 1 0 0 .775Zm-11.739 0a.514.514 0 0 1 .513.513v1.129h-.128a2.014 2.014 0 0 0-1.359.493.627.627 0 0 1-.68.085.618.618 0 0 1-.361-.571v-1.649ZM23.8 22.378a4.561 4.561 0 0 1-3.184 2.872 6.886 6.886 0 0 1-2.185.345H8.02a6.886 6.886 0 0 1-2.185-.345c-3.3-1.1-3.436-3.533-3.374-4.4h2.523v.133a1.539 1.539 0 1 0 3.077 0v-.133h15.924a4.184 4.184 0 0 1-.185 1.528Zm1.877-3.988v.341a1.348 1.348 0 0 1-1.346 1.346H8.061v-.891a2.461 2.461 0 0 0 1.217-.6 1.654 1.654 0 0 1 2.306 0 2.387 2.387 0 0 0 1.634.636 2.358 2.358 0 0 0 1.634-.636 1.654 1.654 0 0 1 2.306 0 2.418 2.418 0 0 0 3.268 0 1.621 1.621 0 0 1 1.153-.468 1.255 1.255 0 0 1 .868.317 1.409 1.409 0 0 0 2.309-1.091v-.233a1.348 1.348 0 0 1 .918 1.28Zm-1.346-5.119H2.121a1.348 1.348 0 0 1-1.346-1.346v-.341a1.348 1.348 0 0 1 1.346-1.346h22.207a1.348 1.348 0 0 1 1.346 1.346v.341a1.347 1.347 0 0 1-1.346 1.346Z"
          />
        </g>
      </g>
    </svg>
  );
};
export default SvgFoodRestaurantAndEvents;
